import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const ListingViewingsConductedBy1 = union([
    literal("viewber"),
    literal("designated_person"),
    literal("occupier"),
    literal("unknown"),
]);
